import { useGlobalConfigContext } from '../../global-config'

import {
  type MarketplacePartnerRegisterPageDictionaryOption,
  useMarketplacePartnerRegisterPageGetDictionaryOptionsByName,
} from './useMarketplacePartnerRegisterPageGetDictionaryOptionsByName'

type MarketplacePartnerRegisterPageFormV3DictionaryOptions = {
  accountTypeOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  annualRevenueOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  categoriesOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  countryCodeOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  marketReadinessOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  revenueExpectedOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
  targetCountriesOptions:
    MarketplacePartnerRegisterPageDictionaryOption[] | undefined
}

export const useMarketplacePartnerRegisterPageFormV3DictionaryOptions =
  (): MarketplacePartnerRegisterPageFormV3DictionaryOptions => {
    const { language } = useGlobalConfigContext()

    const countryCodeOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageCountryCodeOptions',
        language,
      )
    const categoriesOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'categories',
        language,
      )
    const targetCountriesOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageTargetCountriesOptions',
        language,
      )
    const marketReadinessOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageMarketReadinessOptions',
        language,
      )
    const accountTypeOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageAccountTypeOptions',
        language,
      )
    const annualRevenueOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageAnnualRevenueOptions',
        language,
      )
    const revenueExpectedOptions =
      useMarketplacePartnerRegisterPageGetDictionaryOptionsByName(
        'marketplacePartnerRegisterPageRevenueExpectedOptions',
        language,
      )

    return {
      accountTypeOptions,
      annualRevenueOptions,
      categoriesOptions,
      countryCodeOptions,
      marketReadinessOptions,
      revenueExpectedOptions,
      targetCountriesOptions,
    }
  }
